import { Avatar, FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import * as React from 'react';

import { TransferToAgentItem } from '../../transferToAgentDropdown';

import styles from './transferToAgentSelectItem.module.scss';

export type TransferToAgentSelectItemProps = {
  item: TransferToAgentItem;
  onSelect(item: TransferToAgentItem): void;
  disabled: boolean;
  active?: boolean;
  tabIndex?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyDown?: (e: React.KeyboardEvent<any>) => void;
};

export const TransferToAgentSelectItem = ({
  item,
  onSelect,
  disabled,
  active,
  tabIndex,
  onKeyDown,
}: TransferToAgentSelectItemProps): React.ReactElement => {
  const rootClass = classNames(
    {
      [styles.disabled]: disabled,
      [styles.rootActive]: active,
      [styles.rootWorking]: item.status === 'working',
      [styles.rootOffline]: item.status === 'offline',
      [styles.rootAway]: item.status === 'away',
    },
    styles.root,
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleKeyDown = (e: React.KeyboardEvent<any>) => {
    if (e.key === 'Enter' && !disabled) {
      e.preventDefault();
      onSelect(item);
    }
    // Delegate other key handling (arrows, etc.) to parent
    onKeyDown?.(e);
  };

  return (
    <FlexBox
      alignItems="center"
      padding="200 300"
      gap="250"
      className={rootClass}
      role="menuitem"
      aria-disabled={disabled}
      tabIndex={tabIndex}
      onClick={() => onSelect(item)}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.slotStart}>
        <div className={styles.presenceDot} />
        <Avatar user={{ ...item, avatar_url: item.avatarUrl }} />
      </div>
      <div className={styles.slotMiddle}>{item.name}</div>
      <div className={styles.slotEnd} onClick={(e) => e.stopPropagation()}>
        {item.actions}
      </div>
    </FlexBox>
  );
};
